export default __webpack_public_path__ + "static/media/Landing3.fd5bb2c2.jpg";